import { mapState } from 'vuex';
import { extend } from 'vee-validate';
import { required, numeric, mimes, size } from 'vee-validate/dist/rules';

import apiClient from '@/apiClient';

import FileSelect from '@/components/FileSelect/FileSelect.vue';

// Validation rules
extend('requred', {
  ...required,
  message: 'Укажите сумму'
});

extend('numeric', {
  ...numeric,
  message: 'Стоимость дожна быть числом'
});

extend('mimes', {
  ...mimes,
  message: 'Недопустимый формат'
});

extend('size', {
  ...size,
  message: 'Файл не должен превышать 100 Кб'
});

export default {
  name: 'material-upload',

  computed: {
    ...mapState({
      firmId: state => state.user.profile.id,
      materialTypes: state => state.materials.materialTypes,
      units: state => state.materials.units
    }),

    insertableMaterialTypes() {
      return this.materialTypes.filter(
        materialType => !materialType.preventMaterialInsert
      );
    },

    materialSubtypes() {
      return this.newMaterial.materialTypeId
        ? this.materialTypes.find(
          materialType => materialType.id === this.newMaterial.materialTypeId
        ).subtypes
        : [];
    },

    currentUnit() {
      if (this.newMaterial.materialTypeId === null) return '';
      const { unitId } = this.materialTypes.find(
        materialType => materialType.id === this.newMaterial.materialTypeId
      );
      return this.units.find(unit => unit.id === unitId).title;
    },

    subtypeValidationRules() {
      return this.materialSubtypes.length > 0 ? 'required' : '';
    }
  },

  data() {
    return {
      newMaterial: {
        materialTypeId: null,
        materialSubtypeId: null,
        title: null,
        price: null,
        texture: null
      },
      addedMaterial: null,
      newFile: null,
      oldMaterialTypeId: null
    };
  },

  watch: {
    newMaterial: {
      handler(newMaterial) {
        if (
          newMaterial.materialTypeId &&
          newMaterial.materialTypeId !== this.oldMaterialTypeId
        ) {
          this.oldMaterialTypeId = newMaterial.materialTypeId;
          this.newMaterial.materialSubtypeId = null;
        }
      },
      deep: true
    },
    newFile(newFile) {
      if (newFile) {
        const reader = new FileReader();
        reader.onload = () => {
          this.newMaterial.texture = reader.result;
        };
        reader.readAsDataURL(newFile);
      } else {
        this.newMaterial.texture = null;
      }
    }
  },

  methods: {
    resetForm() {
      for (const key in this.newMaterial) {
        this.newMaterial[key] = null;
      }
      this.newFile = null;
      this.$refs.fileselect.reset();
      this.$nextTick(() => {
        this.$refs.form.reset();
      });
    },

    addMaterial() {
      return this.$refs.form.validate().then(success => {
        if (!success) {
          return;
        }
        return new Promise((resolve, reject) => {
          apiClient
            .post(`/firms/${this.firmId}/materials`, this.newMaterial)
            .then(resp => {
              this.flashSuccess('Материал добавлен');
              this.addedMaterial = resp.data[0];
              this.resetForm();
              resolve(resp);
            })
            .catch(err => {
              this.flashError('Произошла ошибка');
              reject(err);
            });
        });
      });
    },

    showNewMaterial() {
      this.$emit('clickShowNewMaterial', this.addedMaterial.materialTypeId);
    },

    validateTexture(e) {
      this.newFile = e;
      this.$refs.imageprovider.syncValue(e);
    }
  },

  components: {
    FileSelect
  }
};
